<template>
  <wdw-dynbox title="Passwort ändern">
    <Form @submit="onSubmitChangePasswordForm">
      <div id="wdw-changepassword-form" class="wdw-form">
        <form-control-input
          label="Aktuelles Passwort"
          type="password"
          name="old_password"
          code="old_password"
          :serverError="data.errors['old_password']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          help="Bitte geben Sie hier Ihr aktuelles Passwort ein."
          parentFormId="wdw-changepassword-form"
          defaultvalue=""
        />
        <p />
        <form-control-input
          label="Neues Passwort"
          type="password"
          name="new_password"
          code="new_password"
          :serverError="data.errors['new_password']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          :help="passwordHelpText"
          parentFormId="wdw-changepassword-form"
          defaultvalue=""
        />
        <p />
        <form-control-input
          label="Neues Passwort (Wiederholung)"
          type="password"
          name="new_password_repeat"
          code="new_password_repeat"
          :serverError="data.errors['new_password_repeat']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          help="Bitte widerholen Sie hier das neue Passwort."
          parentFormId="wdw-changepassword-form"
          defaultvalue=""
        />
        <p />
        <div class="alert alert-info" role="alert">
          <p v-html="passwordExtraHelpText"></p>
        </div>
        <button type="submit" class="btn btn-primary btn-form-submit" :disabled="data.loading" name="submit">
          Passwort ändern
        </button>
        &nbsp;
        <button
          type="button"
          class="btn btn-default btn-form-cancel"
          :disabled="data.loading"
          name="cancel"
          @click="emitClose()"
        >
          Abbrechen
        </button>
        <vue-loading v-if="data.loading" />
      </div>
    </Form>
  </wdw-dynbox>
</template>

<script>
import { userStore } from '@/store/user-store';
import useConverter from '@/composables/general/useConverter';
import { onMounted, reactive, computed, ref } from 'vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';

import { Form } from 'vee-validate';
import VueLoading from '@/components/general/Loading';
import FormControlInput from '@/components/general/FormControl/Input';

const UserRepository = RepositoryFactory.get('user');
const DomainRepository = RepositoryFactory.get('domain');

export default {
  name: 'change-password',

  props: {},
  emits: ['close'],

  setup(props, context) {
    const data = reactive({
      // Server-related errors
      errors: {},
      //show loading view
      loading: false,
    });
    const { toBool } = useConverter();

    //+---------------------+
    //|   computed          |
    //+---------------------+

    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const passwordHelpText = computed(() => {
      return (
        'Bitte wählen Sie heir ein neues Passwort, das nicht allzu einfach zu erraten ist. ' +
        "'12345' oder 'Passwort' sind <strong>keine</strong> empfohlenen Passwörter. " +
        'Bitte geben Sie es anschließend <strong>erneut</strong> in der zweiten Eingabebox ein.'
      );
    });
    const passwordExtraHelpText = computed(() => {
      return (
        'Für das Passwort verwenden Sie bitte mindestens 8 Zeichen. ' +
        'Das Passwort muss mindestens eine <strong>Nummer</strong>, einen <strong>Klein-</strong> und einen <strong>Großbuchstaben</strong>, ' +
        'sowie eines der folgenden <strong>Sonderzeichen</strong> enthalten:' +
        '<strong> ! ? @ § # $ % & ( ) * + ~ - _ . , : ; < = > [ ] { } ^ ` " &#39; | / &#92; </strong>'
      );
    });

    //+--------------------+
    //|    Methods         |
    //+--------------------+

    function emitClose(message) {
      context.emit('close', message);
    }

    const onSubmitChangePasswordForm = (values, actions) => {
      data.loading = true;
      data.errors = [];

      UserRepository.putPassword(user.value.id, values)
        .then(resp => {
          data.loading = false;
          actions.resetForm();
          emitClose('Das Passwort wurde erfolgreich geändert.');
        })
        .catch(err => {
          data.loading = false;
          const errData = err.response.data.message;
          if (errData.includes('old password')) {
            data.errors['old_password'] = errData;
          } else if (errData.includes('too weak')) {
            data.errors['new_password'] = errData;
            data.errors['new_password_repeat'] = errData;
          } else if (errData.includes('new password')) {
            data.errors['new_password_repeat'] = errData;
          } else {
            data.errors['old_password'] = errData;
          }
        });
    };

    return {
      // ---VARIABLE---
      // Computed methods
      passwordHelpText,
      passwordExtraHelpText,
      // Listeners
      onSubmitChangePasswordForm,
      emitClose,
      // Other
      toBool,
      data,
    };
  },

  components: {
    WdwDynbox,
    Form,
    FormControlInput,
    VueLoading,
  },
};
</script>
